import React from "react";
import { Outlet } from "react-router";

function RenewWrapper() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default RenewWrapper;
